import { useGlobalNotificationStore } from '@/modules/notification/store/GlobalNotification.store';

/**
 * Store legado de notificações.
 *
 * @deprecated Use `useGlobalNotificationStore` em `@/modules/notification/store/GlobalNotification.store`.
 * Esta função é apenas um alias tipado para manter compatibilidade com código antigo.
 */
export const useNotificationStore = () => {
  return useGlobalNotificationStore();
};
